import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`I'm Charles, I am 17yrs old, I live in Sudbury ON. I am currently pursuing a certification in Full-Stack Web Development at Carleton U.`}</p>
    <p>{`I'm an experienced Digital Marketer, Community Leader, and Founder. My overall goal is to acquire new skills and assist in making a better future for all through the use of tech & blockchains.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      